var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-button',{ref:"resendButton",attrs:{"size":_vm.size,"type":_vm.type,"color":_vm.color,"disabled":_vm.isDisabled},on:{"click":_vm.handleClick}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }